export const decodeJWT = (token) => {
    try {
        if (!token) return null;  // Fallback, wenn kein Token übergeben wurde
        const base64Url = token.split('.')[1];  // Payload-Teil des JWT
        if (!base64Url) return null;  // Fallback, wenn das Token nicht richtig formatiert ist
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Invalid JWT:', error);  // Optional: Log des Fehlers
        return null;
    }
};
